import React from 'react';
import { Check } from 'lucide-react';
import { commonStyles } from '../styles/commonStyles';

interface CheckBulletListProps {
  items: string[];
  variant?: 'default' | 'emphasis';
}

export const CheckBulletList: React.FC<CheckBulletListProps> = ({ items, variant = 'default' }) => {
  const emphasis = variant === 'emphasis';
  return (
    <ul style={emphasis ? commonStyles.baseCoverageList : commonStyles.plainList}>
      {items.map((item) => (
        <li key={item} style={emphasis ? commonStyles.baseCoverageBullet : commonStyles.bulletItem}>
          <Check
            size={16}
            color={emphasis ? 'var(--primary-color, #056666)' : 'var(--success-color, #22c55e)'}
            style={commonStyles.iconNudge}
          />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
};

export default CheckBulletList;
